import { useInactiveUpdate } from 'apps/builder/lib/hooks/inputHooks'
import { IconTooltip } from 'apps/studio/components/shared/IconTooltip'

export const StudioTextInput = ({
  id,
  placeholder,
  value = '',
  onChange,
  label,
  tooltipContent = '',
  disabled,
  validation = false,
  autoFocus = false,
  truncate = false,
  direction = 'left',
  additionalClasses,
  additionalProps = {},
  IconComponent = null,
  iconPosition = 'leading',
  settingType = 'longTextInput',
}) => {
  const { inputValue, errors, handleChange, handleBlur, handleKeyUp } =
    useInactiveUpdate(value, validation, onChange, { ...additionalProps })

  const inputClassNames = [
    settingType === 'longTextInput'
      ? 'input-fields__textarea'
      : 'input-fields__input',
    truncate && 'clipped-text',
    errors && 'studio--field-error',
    IconComponent && 'with-icon',
    settingType === 'longTextInput' && 'textarea--constrained',
  ]
    .filter(Boolean)
    .join(' ')

  const commonProps = {
    id,
    className: inputClassNames,
    value: inputValue,
    autoFocus,
    placeholder,
    onChange: ({ target }) => {
      const { value } = target
      handleChange(value)
    },
    onKeyUp: handleKeyUp,
    onBlur: handleBlur,
    disabled,
    ...additionalProps,
  }

  return (
    <div
      className={`gcds--input-fields input--secondary ${
        additionalClasses || ''
      }`}
    >
      {label && (
        <label htmlFor={id} className="input-fields__label">
          {label}
          {tooltipContent && (
            <IconTooltip
              tooltipContent={tooltipContent}
              width="medium"
              position="left"
            />
          )}
        </label>
      )}
      <div className={`input-fields--wrapper ${direction || ''}`}>
        {IconComponent && iconPosition === 'leading' && (
          <div className="input-fields__icon-container icon--leading">
            <IconComponent />
          </div>
        )}
        {settingType === 'longTextInput' ? (
          <textarea {...commonProps} />
        ) : (
          <input {...commonProps} />
        )}
        {IconComponent && iconPosition === 'trailing' && (
          <div className="input-fields__icon-container icon--trailing">
            <IconComponent />
          </div>
        )}
      </div>
      {errors && (
        <div className="field-error--wrap">
          <span className="field-error--message">{errors}</span>
        </div>
      )}
    </div>
  )
}
